import ArrowBack from '@mui/icons-material/ArrowBack';
import ArrowForward from '@mui/icons-material/ArrowForward';
import { IconButton } from '@mui/material';
import { ReactElement } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import { tss } from 'tss-react/mui';

const MyCarousel = ({
  children,
  responsive,
  partialVisible,
  itemClass,
  blackArrows
}: {
  children: ReactElement[] | ReactElement;
  responsive: {
    [key: string]: {
      breakpoint: {
        max: number;
        min: number;
      };
      items: number;
    };
  };
  partialVisible?: boolean;
  blackArrows?: boolean;
  itemClass?: string;
}) => {
  const CustomLeftArrow = ({ onClick }: { onClick: Function }) => {
    // onMove means if dragging or swiping in progress.
    return (
      <div style={{ position: 'absolute', left: '-30px' }}>
        <IconButton
          size="small"
          onClick={() => onClick()}
          aria-label="Search history"
        >
          <ArrowBack style={{ fill: blackArrows ? '#000' : '#fff' }} />
        </IconButton>
      </div>
    );
  };
  const CustomRightArrow = ({ onClick }: { onClick: Function }) => {
    // onMove means if dragging or swiping in progress.
    return (
      <div style={{ position: 'absolute', right: '-30px' }}>
        <IconButton
          size="small"
          onClick={() => onClick()}
          aria-label="Search history"
        >
          <ArrowForward style={{ fill: blackArrows ? '#000' : '#fff' }} />
        </IconButton>
      </div>
    );
  };
  const CustomButtonGroup = ({
    next,
    previous
  }: {
    next: Function;
    previous: Function;
  }) => {
    return (
      <div
        className="custom-button-group"
        style={{
          position: 'absolute',
          top: '45%',
          height: '20%',
          width: '100%',
          zIndex: 0
        }}
      >
        <CustomLeftArrow onClick={() => previous()} />
        <CustomRightArrow onClick={() => next()} />
      </div>
    );
  };
  const { classes } = useStyles();
  return (
    <div
      style={{
        position: 'relative',
        height: '100%'
      }}
    >
      <Carousel
        additionalTransfrom={0}
        arrows={false}
        autoPlaySpeed={3000}
        centerMode={false}
        containerClass="container-with-dots"
        draggable
        className={classes.customCarousel}
        focusOnSelect={false}
        itemClass={itemClass}
        infinite
        keyBoardControl
        minimumTouchDrag={80}
        pauseOnHover
        renderArrowsWhenDisabled={false}
        renderButtonGroupOutside={true}
        customButtonGroup={
          Array.isArray(children) && children.length > 1 ? (
            //@ts-ignore
            <CustomButtonGroup />
          ) : null
        }
        renderDotsOutside={false}
        responsive={responsive}
        rewind={false}
        rewindWithAnimation={false}
        rtl={false}
        partialVisible={partialVisible ?? false}
        shouldResetAutoplay
        showDots={false}
        slidesToSlide={1}
        swipeable
      >
        {children}
      </Carousel>
    </div>
  );
};

export default MyCarousel;
const useStyles = tss.create(() => ({
  customCarousel: {
    zIndex: 1,
    height: '100%'
  }
}));
